<template>
  <ValidationObserver
    ref="observer"
    v-slot="{ valid, dirty }"
  >
    <NavTabs
      customClass="capitalize_title"
      :tabs="tabs"
      :activeTab="newActiveTab"
      @sendData="updateData"
    />

    <SlotScopeWatcher
      :value="dirty"
      @change="$emit('dirtyChanged', dirty)"
    />
    <SlotScopeWatcher
      :value="valid"
      @change="$emit('validChanged', valid)"
    />
  </ValidationObserver>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import { ValidationObserver } from 'vee-validate';
import SlotScopeWatcher from '@/components/shared/widgets/forms/validationHelper/SlotScopeWatcher';
import NavTabs from '@/components/shared/widgets/Nav-tabs.vue';
import ComponentIdentification from '@/components/forms/technicalFile/cooling/forms/ComponentIdentification';

import OperatingConditions from '@/components/forms/technicalFile/cooling/forms/OperatingConditions';
import Filtration from '@/components/forms/technicalFile/cooling/forms/Filtration';
import TowerCells from '@/components/forms/technicalFile/cooling/forms/TowerCells';
import OtherInformations from '@/components/forms/technicalFile/cooling/forms/OtherInformations';
import lockService from '@/utilities/lockService';


export default {
    components: {
        ValidationObserver,
        SlotScopeWatcher,
        NavTabs,
    },
    props: {
        node: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            loading: false,
            tabs: [],
            components: [ComponentIdentification, OperatingConditions, Filtration, TowerCells, OtherInformations],
            empty: {
                componentName: this.node?.name,
                componentIdentification: {
                    regulatoryIdentification: '',
                    auditDate: '',
                },
                operatingConditions: {
                    coolingSystemName: '',
                    annualMakeUpVolume: {
                        value: null,
                        units: null,
                    },
                    annualBlowdownVolume: {
                        value: null,
                        units: null,
                    },
                    makeUpSource: [],
                    blowDownDischargeType: [],
                    recirculationRate: {
                        value: null,
                        units: null,
                    },
                    hotReturnTemp: {
                        value: null,
                        units: null,
                    },
                    coldSupplyTemp: {
                        value: null,
                        units: null,
                    },
                    maximumSkinTemp: {
                        value: null,
                        units: null,
                    },
                    totalSystemVolume: {
                        value: null,
                        units: null,
                    },
                    systemMetallurgy: [],
                    deadlegsPresent: {
                        enabled: null,
                        note: '',
                    },
                    operationType: [],
                    durationOfShadowns: {
                        value: null,
                        units: null,
                    },
                    daysInOperation: {
                        value: null,
                        units: null,
                    },
                    controlSystem: [],
                },
                filtration: {
                    type: null,
                    operation: null,
                    capacity: {
                        value: null,
                        units: null,
                    },
                    filtration: null,
                },
                towerCells: [{
                    descriptionIdentifier: '',
                    type: null,
                    towerMetallurgy: [],
                    model: '',
                    coolingCapacity: {
                        value: null,
                        units: null,
                    },
                    fillType: [],
                    coldSumpType: null,
                    driftEliminators: null,
                },
                ],
                otherInformation: {
                    note: '',
                    files: [],
                },
            },
            data: {
                nodeInfo: null,
            },
            model: null,
        };
    },
    computed: {
        ...mapGetters([
            'activeTab',
            'site',
            'userLang',
            'hasPermission',
        ]),
        newActiveTab: {
            get() {
                return this.activeTab;
            },
            set(newValue) {
                this.$store.dispatch('changeActiveTab', newValue);
            },
        },
        readonly() {
            return !this.hasPermission('techFiles.edit');
        },
    },
    mounted() {
        window.addEventListener('beforeunload', this.handleUnload);
    },

    async created() {
        this.loading = true;
        await this.$store.dispatch('changeActiveTab', 0);
        await this.getNodeInfo();
        if (!this.units) {
            await this.loadUnits({ siteId: this.site.id, lang: this.userLang });
        }
        this.model = this.data.nodeInfo ? { ...this.data.nodeInfo, componentName: this.node?.name } : this.empty;
        this.tabs = this.tableHeaders();
        this.loading = false;
    },
    beforeDestroy() {
        if (this.node && this.node.ref) {
            lockService.releaseLock(this.node.ref, 'TechnicalFileCooling');
        }
        window.removeEventListener('beforeunload', this.handleUnload);
    },
    methods: {
        ...mapActions({
            loadUnits: 'getUnits',
        }),
        async getNodeInfo() {
            const { data } = await this.$rq.getNodeInfo(this.site.id, this.node.ref);
            if (Object.keys(data).length) this.data.nodeInfo = data;
        },
        handleUnload() {
            if (this.node && this.node.ref) {
                lockService.releaseLock(this.node.ref, 'TechnicalFileCooling');
            }
        },
        tableHeaders() {
            const headers = this.components.map((component, index) => ({
                index,
                props: { ...this.model, readonly: this.readonly },
                name: this.$t(`technicalFile.cooling.step${index}.title`),
                component: Vue.component(`tab-${index}`, component),
            }));
            this.$store.dispatch('setTabs', headers);
            return headers;
        },
        updateData(newData) {
            this.model = { ...this.model, ...newData };
            this.$emit('sendData', this.model);
        },
    },
};
</script>
